import baseApi from "@/api/baseApi";

const api = {
  async getAberration(data) {
    //     #: null
    // aberrationId: "559868"
    // category: "2"

    const response = await baseApi({
      method: "post",
      url: `/aberration/aberration`,
      data: data,
    });

    return response.data;
  },

  async aberrationInsertupdate(data) {
    const response = await baseApi({
      method: "post",
      url: `/aberration/insertupdate`,
      data: data,
    });

    return response.data;
  },

  async ruhInsertupdate(data) {
    const response = await baseApi({
      method: "post",
      url: `/ruh/insertupdate`,
      data: data,
    });

    return response.data;
  },

  async getActions(data) {
    const response = await baseApi({
      method: "post",
      url: `/actions`,
      data: data,
    });

    return response.data;
  },

  async getActionsCount(data) {
    const response = await baseApi({
      method: "post",
      url: `/actions/count`,
      data: data,
    });

    return response.data;
  },

  async getMyActions() {
    const response = await baseApi({
      method: "get",
      url: `/actions/mine`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getActionsFilteroptions() {
    const response = await baseApi({
      method: "get",
      url: `/aberration/actions/filteroptions`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getActionsDetails(id: number) {
    const response = await baseApi({
      method: "get",
      url: `/aberration/actions/details/${id}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async saveAction(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/action/save`,
      data: data,
    });

    return response.data;
  },

  async createFromChecklistItem(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/aberration/createfromchecklistitem`,
      data: data,
    });

    return response.data;
  },

  async getChecklistAbrrebationActions(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/aberrebation/checklistActions`,
      data: data,
    });

    return response.data;
  },

  async saveChecklistAbrrebationActions(data: any) {
    const response = await baseApi({
      method: "post",
      url: `/aberrebation/checklistAction/save`,
      data: data,
    });

    return response.data;
  },
};

export default api;
